
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import Autocomplete from "./GroupedAutocomplete.vue";
import { Option } from "@/Web/Contracts";
import { CustomError } from "@Internal/Models";

@Component({
    components: {
        Autocomplete
    }
})
export default class EmailCampaignRecipients extends Vue {
    @Prop( { default: () => [] } )
    ToExclude!: ( any )[];

    @Prop( { default: () => [] } )
    Value!: Option[];

    @Prop()
    readonly GetOptions!: ( keyword?: string ) => Promise<[ Option[], CustomError | undefined ]>;

    private values: Option[] = [];
   

    /* On émet toujours un NOUVEAU tableau plutôt que de muter `values` en place :
       `values` partage la référence du tableau passé en prop (souvent la copie de
       travail d'un Form). Une mutation in-place + ré-émission de la même référence
       ne déclenche ni la réactivité Vue ni le diff du Form ( la barre "Enregistrer"
       ne sortait pas ), et le watch sur SelectedOptions ne se rafraîchissait pas. */
    // @Emit( "Update" )
    private selectRecipients( value: Option ) {
        if(value === undefined) {
            return this.values;
        }

        if( this.values.find( option => option.Id === value.Id ) !== undefined ) {
            return this.values;
        }

        this.values = [ ...this.values, value ];

        this.$emit( "Select", this.values );
        return this.values;
    }

    @Watch( "Value", { immediate: true } )
    private onValueUpdate( value: ( Option )[] ) {
        this.values = value;
    }

    private deselectRecipient( target: Option ) {
        this.values = this.values.filter( value => !(
            value.constructor === target.constructor &&
            value.Id === target.Id
        ));

        this.$emit( "Select", this.values );
    }
}
